<template>
    <ul class="sidebar-nav">
        <li class="nav-item show" v-for="item in menu" v-show="typeof access[item.access] !== 'undefined'">
            <a :class="{'nav-link nav-group-toggle': (typeof item.items !== 'undefined'), 'nav-link': (typeof item.items === 'undefined')}" @click="(item.to) ? $router.push(item.to) : item.active = (!item.active)">
                <span class="me-3 glifoNavBox">
                    <Glifo v-if="item.glifo" :name="item.glifo"/>
                    <i v-else :class="item.icon"></i>
                </span>
                {{ navLabel(item.name) }}
            </a>
            <ul class="nav-group-items" style="height: auto;" v-show="item.active">
                <li class="nav-item" v-for="child in item.items" v-show="typeof access[child.access] !== 'undefined'">
                    <a class="nav-link" aria-current="page" @click="$router.push(child.to)">{{ navLabel(child.name) }}</a>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
import {computed} from 'vue'
import {mapGetters, useStore} from 'vuex'
import navMenu from '/src/_nav'
import toolbox from '@/toolbox'
import Glifo from '@/components/Glifo.vue'

export default {
    name: 'AppSidebar',
    components: { Glifo },
    data() {
        return {
            menu: [],
            access: {},
        };
    },
    computed: {
        ...mapGetters({
            loading: 'loading',
            authInfo: 'authInfo',
        })
    },
    watch: {
        authInfo(data) {
            console.log(data);
        }
    },
    mounted() {
        this.menu = navMenu;

        if (typeof this.authInfo.m !== 'undefined') {
            this.access = { ...this.authInfo.m };
            // Marcador para que los menús dinámicos siempre pasen el filtro de access
            this.access['__dynamic'] = true;

            // Administración de marcas: no es un acceso por rol, porque un rol
            // vive dentro de una marca y esto opera por encima de todas. El
            // backend lo resuelve y lo devuelve como `ba`; acá sólo decide si
            // la opción se ve. La protección real está en el controlador.
            if (this.authInfo.ba) {
                this.access['__brandadmin'] = true;
            }
        }

        this.cargarMenusDinamicos();
    },
    methods: {
        // Si el name comienza con "nav." es una llave i18n; si no, se devuelve crudo
        // (compat con cualquier item legacy que aún no haya sido migrado).
        navLabel(name) {
            if (typeof name === 'string' && name.indexOf('nav.') === 0) {
                return this.$t(name);
            }
            return name;
        },
        cargarMenusDinamicos() {
            toolbox.doAjax('GET', 'menus/sidebar', {},
                (response) => {
                    const data = response.data || [];
                    if (!data.length) return;
                    const dinamicos = data.map((n) => this.transformarMenu(n));
                    this.menu = [...dinamicos, ...navMenu];
                },
                () => { /* silencioso: si falla, sidebar sigue funcionando con menú estático */ }
            );
        },
        transformarMenu(node) {
            const tieneHijos = node.children && node.children.length > 0;
            const item = {
                component: tieneHijos ? 'CNavGroup' : 'CNavItem',
                name: node.label,
                access: '__dynamic',
                icon: node.icono || 'ti ti-folder',
                active: false,
            };
            if (tieneHijos) {
                item.to = '';
                item.items = node.children.map((c) => this.transformarMenu(c));
            } else {
                item.to = this.resolverDestino(node);
            }
            return item;
        },
        resolverDestino(node) {
            if (node.tipo === 'base' && node.targetId) {
                return `/menus/${node.id}`;
            }
            if (node.tipo === 'flujo' && node.productoToken) {
                // Enlazamos al runtime del flujo (pantalla de inicio del producto).
                return `/flow/${node.productoToken}/view`;
            }
            return '';
        },
    },
}
</script>
